import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-before-login-notifications',
  templateUrl: './before-login-notifications.page.html',
  styleUrls: ['./before-login-notifications.page.scss'],
})
export class BeforeLoginNotificationsPage implements OnInit {
  url: string = '';
  isMultistep: boolean = false;
  before_login_message: string = '';
  sanitizedHtml: SafeHtml;
  isLoading: boolean = true;

  currentStep: number = 0;
  totalSteps: number = 0;
  currentContent: SafeHtml;
  currentButtonLabel: string = '';
  currentButtonStyle: string = '';
  multistepData: any = null;
  acceptanceLabel: string = '';
  isAgreed: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private router: Router,
    private authService: AuthService
  ) {}

  async ngOnInit() {
    await this.fetchSettings();

    if (localStorage.getItem('portal_settings')) {
      let settings = JSON.parse(localStorage.getItem('portal_settings'));

      if (settings?.additional_settings?.before_login && settings?.additional_settings?.before_login?.before_login_allow_multistep == "yes") {
        this.isMultistep = true;
        this.url = this.route.snapshot.queryParams.url;
        this.multistepData = settings.additional_settings.before_login.multistep_notification;
        this.totalSteps = Object.keys(this.multistepData.multisteps || {}).length;

        if (this.totalSteps >= 0 || settings?.additional_settings?.before_login?.before_login_allow_multistep === "yes") {
          this.loadStep(0);
        } else {
          this.isMultistep = false;
          const notificationMessage = settings.additional_settings.custom_notifications?.before_login;
          if (notificationMessage) {
            this.before_login_message = notificationMessage;
            this.sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(this.before_login_message);
          }
        }
        this.isLoading = false;
      }
      else if (settings?.additional_settings?.custom_notifications && settings?.additional_settings?.custom_notifications?.before_login) {
        const notificationMessage = settings.additional_settings.custom_notifications.before_login;
        this.before_login_message = notificationMessage;
        this.sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(this.before_login_message);
        this.isMultistep = false;
        this.isLoading = false;
      }
      else {
        this.isLoading = false;
        window.location.href = '/login?dynamic=1';
      }
    }
    else {
      this.isLoading = false;
      window.location.href = '/login?dynamic=1';
    }
  }

  loadStep(stepNumber: number) {
    if (stepNumber === 0) {
      const mainContent = this.multistepData.main_content;
      this.currentContent = this.sanitizer.bypassSecurityTrustHtml(mainContent.textarea);
      this.currentButtonLabel = mainContent.label || 'Continue';
      this.currentButtonStyle = mainContent.btn_style || 'btn-primary';
      this.acceptanceLabel = mainContent.agreement_checkbox_label;

      if (this.acceptanceLabel.trim() == '') {
        this.isAgreed = true;
      }
    }
    else {
      if (this.multistepData.multisteps && this.multistepData.multisteps[stepNumber]) {
        const stepContent = this.multistepData.multisteps[stepNumber];
        this.currentContent = this.sanitizer.bypassSecurityTrustHtml(stepContent.textarea);
        this.currentButtonLabel = stepContent.label || 'Continue';
        this.currentButtonStyle = stepContent.btn_style || 'btn-primary';
        this.acceptanceLabel = stepContent.agreement_checkbox_label;

        if (this.acceptanceLabel.trim() == '') {
          this.isAgreed = true;
        }
      } else {
        const mainContent = this.multistepData.main_content;
        this.currentContent = this.sanitizer.bypassSecurityTrustHtml(mainContent.textarea);
        this.currentButtonLabel = mainContent.label || 'Continue';
        this.currentButtonStyle = mainContent.btn_style || 'btn-primary';
        this.acceptanceLabel = mainContent.agreement_checkbox_label;

        if (this.acceptanceLabel.trim() == '') {
          this.isAgreed = true;
        }
      }
    }
    this.currentStep = stepNumber;
  }

  nextStep() {
    if (this.totalSteps === 0) {
      localStorage.removeItem('is_login');
      localStorage.setItem('before_login_completed', 'true');
      window.location.href = '/login?dynamic=1';
      return;
    }

    if (this.currentStep === 0) {
      this.loadStep(1);
    }
    else if (this.currentStep < this.totalSteps) {
      this.loadStep(this.currentStep + 1);
    }
    else {
      localStorage.removeItem('is_login');
      localStorage.setItem('before_login_completed', 'true');
      window.location.href = '/login?dynamic=1';
    }
  }

  previousStep() {
    if (this.currentStep > 1) {
      this.loadStep(this.currentStep - 1);
    }
    else if (this.currentStep === 1) {
      this.loadStep(0);
    }
  }

  fetchSettings() {
    return new Promise<void>((resolve) => {
      this.authService.portalSettings2().subscribe((res: any) => {
        let portalSettings = res.data;
        localStorage.setItem('portal_settings', JSON.stringify(portalSettings));
        resolve();
      }, (error) => {
        resolve();
      });
    });
  }

  onSubmit() {
    localStorage.setItem('before_login_completed', 'true');
    window.location.href = '/login?dynamic=1';
  }
}
